import React, { useState, useEffect } from 'react';
import PageHeading from '../../components/PageHeading';
import { PlayCircleOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { debounce } from 'lodash';
import { Button, Input, message, Table, Tag } from 'antd';
import axiosInstance from '../../utils/axios';
import { dateFormat } from '../../utils/dateFormats';
import { useNavigate } from 'react-router-dom';

const Movies = () => {
	const navigate = useNavigate();
	const [movies, setMovies] = useState({
		results: []
	});
	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);

	useEffect(() => {
		const delayFetch = debounce(() => {
			fetchData();
		}, 550); // 550ms debounce

		delayFetch();

		return () => delayFetch.cancel();

		// eslint-disable-next-line
	}, [search, page]);

	const handleSearch = (e) => {
		setSearch(e.target.value);
		setPage(1);
	}

	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get(`movie/movie/?page=${page}&search=${search}`);
			setMovies(response.data);
		} catch (error) {
			message.error("Failed to fetch movie");
		} finally {
			setLoading(false);
		}
	};


	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Directed by',
			dataIndex: 'directed_by',
			key: 'directed_by',
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			render: text => text === 'coming_soon' ? <Tag color="blue">Coming Soon</Tag> : <Tag color="gold">Now Showing</Tag>
		},
		{
			title: 'Language',
			dataIndex: 'language',
			key: 'language',
			render: (_, record) => (
				<>{record.language && record.language.name}</>
			)
		},
		{
			title: 'Created at',
			dataIndex: 'created_at',
			key: 'created_at',
			render: text => dateFormat(text),
		},
		{
			title: 'Action',
			dataIndex: '',
			key: 'actions',
			render: (_, record) => (
				<>
					<Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/admin/movie/update-movie/${record.id}`)} />
				</>
			)
		},
	];

	return (
		<div className='dashboard'>
			<PageHeading name="Movies" icon={<PlayCircleOutlined />} />
			<div style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '12px',
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: 16
			}}>
				<Input
					placeholder="Search here"
					prefix={<SearchOutlined />}
					style={{ width: "190px" }}
					onChange={(e) => handleSearch(e)}
				/>
				<Button type="primary" onClick={() => navigate("/admin/movie/add-new")}>Add new</Button>
			</div>

			<Table
				dataSource={movies.results}
				loading={loading}
				columns={columns}
				rowKey="id"
				scroll={{ x: 'max-content' }}
				pagination={{
					current: page,
					pageSize: 20,
					total: movies.count,
					onChange: (newPage, _) => {
						setPage(newPage);
					}
				}}
			/>
		</div>
	)
}

export default Movies